import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import SmartDataTable from "../../components/SmartDataTable";
import { useOrg } from "../orgs/org-context";

export default function GameList() {
  const navigate = useNavigate();
  const { activeOrgId } = useOrg();

  const columns = useMemo(() => [
    { label: "", type: "count", value: "__count", width: "48px" },

    { label: "Name", value: "name", search: "name", width: "240px" },

    {
      label: "Status",
      value: "status",
      width: "120px"
    },

    {
      label: "Updated",
      value: "updatedAt",
      width: "180px",
      type: "render",
      render: (r) =>
        r.updatedAt ? new Date(r.updatedAt).toLocaleString() : ""
    }
  ], []);

  const buttons = [
    { label: "Edit", class: "btn-green", action: "/game/edit/{_id}" },
    { label: "Board", class: "btn-blue", action: "/game/board/{_id}" },
    { label: "Copy", class: "btn-gray", requestPath: "/api/scavenger/copy/{_id}", requestMethod: "POST" },
    { label: "Delete", class: "btn-danger", action: "delete" }
  ];

  return (
    <div className="datatable-page">

      <div className="datatable-header-row" style={{ justifyContent: "space-between" }}>
        <div style={{ fontSize: 18, fontWeight: 700, paddingLeft: 20 }}>
          Games
        </div>
      </div>

      <SmartDataTable
        config={{
          columns,
          queryName: "/api/scavenger/list",
          pageSize: 20,
          buttons,
          deletePathTemplate: "/api/scavenger/delete/{_id}",
          deleteMethod: "POST",
          headerActions: (
            <button
              className="btn-green add-new-button"
              onClick={() => navigate("/game/edit/new")}
            >
              Add New Game
            </button>
          ),
          defaultPayload: {
            orgId: activeOrgId
          }
        }}
      />
    </div>
  );
}
